/* Closing call-to-action for the hair and product pages.

   Deliberately "book a consultation" rather than "order": nothing is shipped,
   shade and length are only decided in the salon, and the extensions/wigs
   stock is still arriving. The phone number is the whole conversion path -
   traffic arrives from Google and every step that leaves the site loses it. */

import React from 'react';
import { PHONE_TEL } from '../../config/emailjs';
import { BRAND, GOLD, INK, BODY, CREAM, serif, sans } from './blocks';

const ServiceCta = ({ heading, phone, address, hours }) => (
  <section style={{ padding: '64px 0', background: CREAM }}>
    <div style={{ maxWidth: '640px', margin: '0 auto', padding: '0 24px', textAlign: 'center' }}>
      <p
        style={{
          fontFamily: sans,
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '0.22em',
          textTransform: 'uppercase',
          color: GOLD,
          marginBottom: '12px',
        }}
      >
        Vision Beauty
      </p>

      <h2
        style={{
          fontFamily: serif,
          fontSize: 'clamp(1.75rem, 3.4vw, 2.4rem)',
          fontWeight: 600,
          color: INK,
          margin: '0 0 24px',
          lineHeight: 1.2,
        }}
      >
        {heading}
      </h2>

      <a
        href={`tel:${PHONE_TEL}`}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '12px',
          padding: '16px 38px',
          background: BRAND,
          color: '#fff',
          fontFamily: sans,
          fontSize: '17px',
          fontWeight: 700,
          letterSpacing: '0.03em',
          borderRadius: '9999px',
          textDecoration: 'none',
          boxShadow: '0 8px 28px rgba(144,81,15,0.32)',
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.68A2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z" />
        </svg>
        {phone}
      </a>

      <p style={{ fontFamily: sans, fontSize: '15px', lineHeight: 1.8, color: BODY, margin: '24px 0 0' }}>
        {address}
        {hours && (
          <>
            <br />
            {hours}
          </>
        )}
      </p>
    </div>
  </section>
);

export default ServiceCta;
